import axios from 'axios'
import qs from 'qs'
import { message as Message } from 'antd';
import router from './router';
let http = {
    post: "",
    get: "",
    setHeader: "",
    // url: "http://192.168.1.140:8083",
    // urlLogin: "http://localhost:4444",
    // urlHttp: "https://localhost:4444/#",
    // 前后端同域部署: 浏览器打开 https://buytoapply.ruiqintech.cn 时
    // Caddy 把 /userLogin/... /user/... /contract/... 等路径反代到后端
    // 所以 url 用空串代表同源调接口; 本地开发改成 http://127.0.0.1:8090
    url: "",
    urlLogin: "/#/user/login",
    urlHttp: "/#",
}

http.post = function (api, data, token) {
    // console.log("server",token,localStorage.getItem("userToken"))
    if(!token || token==""){
        if(localStorage.getItem("userToken") && localStorage.getItem("userToken")!=""){
            token = localStorage.getItem("userToken");
        }
    }
    let params = data
    var Headers_ = {
        headers: {
            "token": token,
        }
    }

    return new Promise((resolve, rejext) => {
        //console.log(Headers_)
        axios.post(http.url + api, params, Headers_)
            .then((res) => {
               resolve(res)
            //    console.log("common_0001",res.data)
                if (res.data.resultCode != null && res.data.resultCode == "common_0001") {
                    sessionStorage.setItem("userName", "")
                    sessionStorage.setItem("userToken", "")
                    localStorage.setItem("userToken", "")
                    window.location.href = http.urlLogin;
                }
                return res;
            })
            .catch((response) => {
                console.log(response)
                // 仅 401 / 真正的鉴权问题才跳登录; 网络错误显示提示, 保留表单
                const status = response && response.response && response.response.status;
                if (status === 401) {
                    sessionStorage.removeItem("userName");
                    sessionStorage.removeItem("userToken");
                    localStorage.removeItem("userToken");
                    window.location.href = http.urlLogin;
                } else if (response && response.message == "Network Error") {
                    Message.error("网络异常, 请检查连接或稍后重试");
                }
            })

    })
}

http.get = function (api, token) {
    //let params = qs.stringify(data)
    let Headers_ = {
        headers: {
            "token": token
        }
    }
    return new Promise((resolve, rejext) => {
        axios.get(http.url + api, Headers_)
            .then((res) => {
                resolve(res)
                //console.log("res", res)
                if (res.data.resultCode != null && res.data.resultCode == "common_0001") {
                    sessionStorage.setItem("userName", "")
                    sessionStorage.setItem("userToken", "")
                    localStorage.setItem("userToken", "")
                }
                return res;
            })
            .catch((response) => {
                
                //console.log(response)
                if (response.message == "Network Error") {
                    Message.error("服务器异常，请重试或联系管理员");
                    
                }

            })
    })
}

// adminpost: admin/supe 登录入口用，语义上和 post 一样，发到同一 baseURL
http.adminpost = function (api, data, token) {
    return http.post(api, data, token);
}

http.setHeader = function () {
    //return new Promise((resolve, rejext) => {
    axios.defaults.headers.common["token"] = localStorage.getItem("token")
    //})
}
export default http